import { createDevAuthClient, createSupabaseAuthClient, type AuthClient } from '../platform/auth.ts';
import { config } from './config.ts';

/** The app-wide auth client: Supabase Auth when the project is configured, else the dev backend's sign-in. */
export const auth: AuthClient = config.supabase ? createSupabaseAuthClient(config.supabase.url, config.supabase.publishableKey) : createDevAuthClient(config.backendUrl);
